import { render, staticRenderFns } from "./DynamicProductsLogView.vue?vue&type=template&id=223b2605&"
import script from "./DynamicProductsLogView.vue?vue&type=script&lang=js&"
export * from "./DynamicProductsLogView.vue?vue&type=script&lang=js&"
import style0 from "./DynamicProductsLogView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports